import { StoreWallInterface } from "../../types/store";
import { calcItemPosition, findSectionIndex } from "./calcItemPosition";
import { updateRodBitrixIds } from "../../helpers/updateRodBitrixIds";
import { updateShelfRodIds } from "../../helpers/updateShelfRodIds";

export const moveItem = (id: string, position: number[], currentShelving: StoreWallInterface) => {
    const currentSideSections = structuredClone(currentShelving.sections);
    const newSectionIndex = findSectionIndex(id, position[0]);

    if (newSectionIndex === null) {
        return currentSideSections;
    }

    const newPosition = calcItemPosition(id, position);

    if (newPosition) {
        // Найдем перемещаемый элемент для определения, является ли он полкой
        const movedItem = currentSideSections.flatMap(section => section.items).find(item => item.id === id);
        const isShelfMove = movedItem && movedItem.type?.includes("Полка");
        
        // Если перемещается полка, найдем все роды на той же высоте, в той же секции и с близкой позицией по X
        let associatedRods: Array<{item: any, oldSectionId: string, oldPosition: number[]}> = [];
        if (isShelfMove) {
            const oldShelfPosition = movedItem.position[1];
            const oldShelfPositionX = movedItem.position[0];
            const oldShelfSectionId = movedItem.sectionID;
            currentSideSections.forEach(section => {
                section.items.forEach(item => {
                    if (item.type?.some((t) => t === "Штанга") && 
                        Math.abs(item.position[1] - oldShelfPosition) < 0.01 &&
                        Math.abs(item.position[0] - oldShelfPositionX) < 0.01 &&
                        item.sectionID === oldShelfSectionId &&
                        item.id !== id) {
                        associatedRods.push({
                            item: item,
                            oldSectionId: item.sectionID,
                            oldPosition: [...item.position]
                        });
                    }
                });
            });
        }

        const newCurrentSideSections = currentSideSections.map((section) => ({
            ...section,
            items: section.items.map((item) => {
                if (item.id === id) {
                    // Обновляем позицию основного элемента
                    item.sectionID = currentSideSections[newSectionIndex].id;
                    item.position = newPosition;
                } else if (isShelfMove && associatedRods.some(rod => rod.item.id === item.id)) {
                    // Обновляем позицию связанных родов
                    const rodInfo = associatedRods.find(rod => rod.item.id === item.id);
                    if (rodInfo) {
                        item.sectionID = currentSideSections[newSectionIndex].id;
                        // Перемещаем род на ту же высоту, что и полка, сохраняя его относительную позицию по X и Z
                        item.position = [
                            newPosition[0], // Новая X координата (следуем за полкой)
                            newPosition[1], // Новая Y координата (следуем за полкой)
                            rodInfo.oldPosition[2] // Сохраняем старую Z координату рода
                        ];
                    }
                }
                return item;
            }),
        }));

        // Проверяем, нужно ли пересчитать bitrixId для штанг
        // Это нужно если перемещался любой элемент, который может повлиять на цепочки штанг
        const hasRods = newCurrentSideSections.some(section => 
            section.items.some(item => item.type?.some((t) => t === "Штанга"))
        );
        
        const hasShelfRods = newCurrentSideSections.some(section => 
            section.items.some(item => 
                item.parts.some(part => part.type?.some((t) => t === "Штанга"))
            )
        );
        
        let updatedSections = newCurrentSideSections;
        
        if (hasRods) {
            updatedSections = updateRodBitrixIds(updatedSections);
        }
        
        if (hasShelfRods) {
            updatedSections = updateShelfRodIds(updatedSections);
        }
        
        return updatedSections;
    }
    return currentSideSections;
};
